import { t } from 'i18next'
import React, { useCallback, useMemo, useEffect, useState } from 'react'
import { Button, Form, Alert, Modal, Spinner } from 'react-bootstrap'
import { MdLibraryAdd } from 'react-icons/md'
import { formatedDate } from '../../utils/formatedDate'
import { ButtonWithLoadingState } from '../Buttons'
import UniversalTableWrapperTest from '../Table/UniversalTableWrapperTest'
import BootstrapTable from 'react-bootstrap-table-next'
import { useTableState } from '../Table/TableProvider'
import { getErrorMessageFromApiResponse } from '../../utils/api/apiUtils'
import { APIEndpoints } from '../../utils/api/apiConfig'
import apiClient from '../../utils/api/apiClient'
import { emptyGuid, isEmptyGuid } from '../../utils/emptyGuid'
import ArraySelect from '../Select/ArraySelect'
import { makeCall } from '../../utils/api/makeCall'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { useLocalReceiptsState } from '../../stores/LocalReceiptsProvider'

const StyledHeaderCell = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
const RecommandationsModal = ({
  setShowRecommandationsModal,
}) => {
  const {
    setShowAllLocalReceipts,
    setForceReloadLocalReceipts,
  } = useLocalReceiptsState()
  const [success, setSuccess] = useState('')
  const [error, setError] = useState('')
  const [isSaving, setIsSaving] = useState(false)
  const { tableRef } = useTableState()
  const [recommandations, setRecommandations] = useState([])
  const [storehouses, setStorehouses] = useState([])
  const [/*errorStates*/, setErrorStates] = useState({})
  const [loadingStates, setLoadingStates] = useState({})
  const [allSelected, setAllSelected] = useState(false)
  const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([])
  const [selectedStorehouseId, setSelectedStorehouseId] = useState(null)
  const navigate = useNavigate();
  const selectAll = useCallback(() => {
    if (allSelected || recommandations.length < 1) {
      setAllSelected(false)
      setSelectedCheckBoxes([])
    } else {
      const arrayOfAllIds = recommandations.map((obj) => obj.id)
      setSelectedCheckBoxes(arrayOfAllIds)
      setAllSelected(true)
    }
  }, [recommandations, allSelected])
  const columns = useMemo(
    () => [
      {
        dataField: 'checkBox',
        text: '',
        headerClasses: 'checkBox-header-cell',
        classes: 'checkBox-cell',
        editable: false,
      },
      {
        dataField: 'dateOfCreation',
        text: 'date',
        sort: true,
        editable: false,
        formatter: (cell, row) => formatedDate(cell),
      },
      {
        dataField: 'supplier.displayName',
        text: 'goodsReceiptsTable:supplier',
        sort: true,
        editable: false,
      },
      {
        dataField: 'article.articleNumber',
        text: 'localInventoriesTable:articleNumber',
        sort: true,
        editable: false,
      },
      {
        dataField: 'article.displayName',
        text: 'localInventoriesTable:articleName',
        sort: true,
        editable: false,
      },
      {
        dataField: 'articleVariant.displayName',
        text: 'localInventoriesTable:sizeName',
        sort: true,
        editable: false,
      },
      {
        dataField: 'quantity',
        text: 'requirement',
        sort: true,
        editable: false,
      },
      {
        dataField: 'availableQuantity',
        text: 'localInventoriesTable:currentInventory',
        sort: true,
        editable: false,
      },
    ],
    []
  )
  const preparedColumns = useMemo(() => {
    const tmpColumns = [...columns]
    tmpColumns.forEach((tmpColumn) => {
      tmpColumn.headerFormatter = (column, colIndex, components) => {
        switch (tmpColumn.dataField) {
          case 'checkBox':
            return (
              <span>
                <input
                  type='checkbox'
                  id='checkbox_header'
                  name='scales'
                  checked={allSelected}
                  onChange={selectAll}
                ></input>
              </span>
            )
          default:
            return (
              <>
                <StyledHeaderCell>
                  {column.text}
                  {components.sortElement}
                </StyledHeaderCell>
              </>
            )
        }
      }
    })
    tmpColumns.forEach((tmpColumn) => {
      tmpColumn.text = t(tmpColumn.text)
    })
    const ignoreColumns = () => {
      var result = []
      /*if (!modifiedLocalInventories.find((x) => !isEmptyGuid(x.sizeId)))
        result.push('sizeName')*/
      return result
    }
    return tmpColumns.filter(
      (item) => !ignoreColumns().includes(item.dataField)
    )
  }, [columns, allSelected, selectAll])
  const handleClose = () => {
    setShowRecommandationsModal(false)
  }
  const saveData = async () => {
    let params = {
      storehouseId: selectedStorehouseId,
      recommandationIds: selectedCheckBoxes,
    }
    return await apiClient.postJson(
      APIEndpoints.localstock().recommandations,
      params
    )
  }

  const handleSave = async () => {
    setIsSaving(true)
    setError('')
    try {
      let receiptId = await saveData()
      setSuccess(t('EmployeeFormSidebar:dataSaved'))
      setShowRecommandationsModal(false)
      setForceReloadLocalReceipts(true)
      setShowAllLocalReceipts(true)
      if (!isEmptyGuid(receiptId)) {
        let path = `/localstorage/goodsreceipts/${receiptId}/edit/`;
        navigate(path);
      }
    } catch (e) {
      setError(getErrorMessageFromApiResponse(e))
    }
    setIsSaving(false)
  }
  const loadStorehouses = useCallback(async () => {
    makeCall('loadStorehouses', async () => {
      let loadedStorehouses = await apiClient.getJson(APIEndpoints.storehouses())
      loadedStorehouses = loadedStorehouses.filter(item => item.isVirtual && !!(item.procGroupIds?.length ?? 0))
      setStorehouses(loadedStorehouses)
    }, setErrorStates, setLoadingStates)

  }, [])
  const getParams = useCallback(() => {
    let params = {};
    if (!isEmptyGuid(selectedStorehouseId)) {
      params["filter.storehouseId"] = selectedStorehouseId;
    }
    return params;
  }, [selectedStorehouseId])
  const loadRecommandations = useCallback(async () => {
    makeCall('loadRecommandations', async () => {
      let params = getParams();
      let loadedRecommandations = await apiClient.getJson(APIEndpoints.localstock().recommandations,
        params,
        true,
        true,
        true,
      )
      let initialRecommandations = loadedRecommandations.data.map((item) => ({
        ...item,
        checkBox: (
          <span>
            <input
              type='checkbox'
              id={item.id}
              name='scales'
              checked={false}
              onChange={() => { }}
            ></input>
          </span>
        ),
      }))
      setRecommandations(initialRecommandations)
    }, setErrorStates, setLoadingStates)

  }, [getParams])
  useEffect(() => {
    loadStorehouses()
  }, [loadStorehouses])
  useEffect(() => {
    if (!isEmptyGuid(selectedStorehouseId)) {
      loadRecommandations()
    }
  }, [selectedStorehouseId, loadRecommandations])
  useEffect(() => {
    setRecommandations((prev) =>
      prev.map((item) => ({
        ...item,
        checkBox: (
          <span>
            <input
              type='checkbox'
              id={item.id}
              name='scales'
              checked={selectedCheckBoxes.includes(item.id)}
              onChange={() => { }}
            ></input>
          </span>
        ),
      }))
    )
  }, [selectedCheckBoxes])
  const onRowClick = (cell, row) => {
    const { cursor } = getComputedStyle(cell.target)
    if (cursor === 'pointer') {
      return false
    }
    if (allSelected) {
      setAllSelected(false)
    }
    if (selectedCheckBoxes.includes(row.id)) {
      var index = selectedCheckBoxes.indexOf(row.id)
      var newValues = [...selectedCheckBoxes]
      newValues.splice(index, 1)
      setSelectedCheckBoxes(newValues)
    } else {
      setSelectedCheckBoxes((prev) => [...prev, row.id])
    }
  }
  return (
    <Modal fullscreen={true} centered show={true} onHide={handleClose} scrollable>
      <Modal.Header closeButton className='pb-0'>
        <Modal.Title>
          <div>
            <p className='m-0 pt-2'>
              {t('goodsReceiptPage:recommandations')}
            </p>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <UniversalTableWrapperTest tableIsLoading={loadingStates.loadRecommandations}>
          <BootstrapTable
            loading={loadingStates.loadRecommandations}
            ref={tableRef}
            noDataIndication={() => {
              ; <div className='no-data-placeholder'>No Data</div>
            }}
            bootstrap4
            keyField='id'
            hover
            data={recommandations}
            columns={preparedColumns}
            bordered={false}
            rowEvents={{ onClick: onRowClick }}
          />
        </UniversalTableWrapperTest>
        {error ? <Alert variant='danger'>{error}</Alert> : null}
        {success ? <Alert variant='success'>{success}</Alert> : null}
      </Modal.Body>
      <Modal.Footer >
        <div className='flex-grow-1 w-100'>
          {loadingStates.loadStorehouses
            ? <div className="d-flex align-items-center justify-content-center"><Spinner animation='border' variant='primary' /></div>
            : <>
              <Form.Group className="mb-3">
                <Form.Label className="d-block">{`${t('reportConfig:warehouseSelection')}${'*'}`}</Form.Label>
                <ArraySelect
                  value={selectedStorehouseId}
                  defaultOption={{ value: emptyGuid, name: t('pleaseSelect') }}
                  options={storehouses}
                  onChange={e => setSelectedStorehouseId(e.target.value)}
                  returnEvent
                />
              </Form.Group>
            </>
          }
        </div>
        <React.Fragment>
          <Button variant='secondary' onClick={handleClose}>
            {t('closeButton')}
          </Button>
          <ButtonWithLoadingState
            variant='primary'
            buttonText={t('createLocalInventory:saveLocalInventory')}
            isLoading={isSaving}
            onClick={handleSave}
            disabled={!(selectedCheckBoxes?.length ?? 0) || isEmptyGuid(selectedStorehouseId)}
          />
        </React.Fragment>
      </Modal.Footer>
    </Modal>
  )
}

const Recommandations = () => {
  const [showRecommandationsModal, setShowRecommandationsModal] =
    useState(false)

  return (
    <>
      <Button
        className='subheader__button btn btn-primary btn-extra-padding mobileButton'
        onClick={() => setShowRecommandationsModal(true)}
      >
        <MdLibraryAdd className='me-3' />
        {t('goodsReceiptPage:recommandations')}
      </Button>
      {showRecommandationsModal ? (
        <RecommandationsModal
          setShowRecommandationsModal={
            setShowRecommandationsModal
          }
        />
      ) : null}
    </>
  )
}
export default Recommandations
